import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { DialogTitle, styled, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { CloseButton } from '../CloseButton/CloseButton.js';

const Title = forwardRef(function DialogTitle$1(_a, ref) {
    var { onClose, children, disableTypography, typographyProps } = _a, rest = __rest(_a, ["onClose", "children", "disableTypography", "typographyProps"]);
    return (jsxs(DialogTitle, Object.assign({}, rest, { ref: ref, children: [disableTypography ? (children) : (jsx(TitleTypography, Object.assign({ variant: "h5" }, typographyProps, { children: children }))), onClose && jsx(DialogCloseButton, { "aria-label": "close", variant: "grey", onClick: onClose })] })));
});
const TitleTypography = styled(Typography)({
    gridColumn: 2,
    justifySelf: "center",
    alignSelf: "center",
    textAlign: "center",
});
const DialogCloseButton = styled(CloseButton)({
    marginRight: 10,
    gridColumn: 3,
    justifySelf: "end",
    alignSelf: "center",
});

export { Title };
//# sourceMappingURL=DialogTitle.js.map
